"use client";

import { Button, buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useToast } from "@/components/ui/use-toast";
import { cn } from "@/lib/utils";
import { pagesPath } from "@/utils/pages-path";
import Link from "next/link";
import { useState } from "react";
import { MdExpandMore } from "react-icons/md";
import { useLogout } from "./use-logout";

export const EmployerAccountActionMenu = ({
  userName,
  params,
}: {
  userName: string;
  params: { officeId: string };
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((p) => !p);
  const close = () => setIsOpen(false);
  const logout = useLogout();
  const { toast } = useToast();

  return (
    <DropdownMenu open={isOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          id="account-menu-button"
          className={cn(
            buttonVariants({ variant: "primary" }),
            "group rounded-full",
          )}
          onClick={toggle}
        >
          {userName}
          <MdExpandMore
            className="relative top-px ml-1 h-3 w-3 transition duration-200 group-data-[state=open]:rotate-180"
            aria-hidden="true"
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="bg-white"
        onCloseAutoFocus={close}
        onEscapeKeyDown={close}
        onPointerDownOutside={close}
        onInteractOutside={close}
        onFocusOutside={close}
      >
        <DropdownMenuItem asChild>
          <Button
            asChild
            variant="ghost"
            className="w-full cursor-pointer focus-visible:ring-0 focus-visible:ring-inset"
          >
            <Link
              href={
                pagesPath.employers
                  ._officeId(params.officeId)
                  .account.setting.$url().path
              }
              onClick={close}
            >
              アカウント
            </Link>
          </Button>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Button
            variant="ghost"
            className="w-full cursor-pointer focus-visible:ring-0 focus-visible:ring-inset"
            onClick={async () => {
              setSubmitting(true);
              close();
              await logout();
              toast({
                title: "ログアウトしました",
                variant: "info",
              });
            }}
            disabled={submitting}
          >
            ログアウト
          </Button>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
